import request from '@/utils/request'

let MeetsApi = {

  /*会议室列表*/
  list(data) {
    return request._post('/shop/plus.meets.Index/index', data);
},
/*添加会议室*/
add(data) {
    return request._post('/shop/plus.meets.Index/add', data);
},
/*修改会议室*/
edit(data) {
    return request._post('/shop/plus.meets.Index/edit', data);
},
/*删除会议室*/
del(data) {
    return request._post('/shop/plus.meets.Index/del', data);
},
/*会议室详情*/
detail(data) {
  return request._post('/shop/plus.meets.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.meets.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.meets.Setting/getSetting', data, errorback);
    },
}
export default MeetsApi;



// WEBPACK FOOTER //
// ./src/api/meets.js